export default "__VITE_ASSET__B7N216o$__"